<template>
    <div>
        <h3>電子書籍</h3>
        <div>
            <p>
                貸し本棚に掲載される<b>完結作品</b>は、電子書籍をダウンロードすることができます。
                電子書籍はepub形式となっており、epub対応リーダーで読むことができます。
            </p>
            <h4>電子書籍のダウンロード</h4>
            <p>
                <img src="/img/help/read/02.png" alt="電子書籍のダウンロード" class="img-thumbnail mb-3">
                電子書籍は、完結作品の目次の「電子書籍のダウンロード」ボタンからダウンロードできます。
                短編の場合は、本文ページのサイドメニューからダウンロードできます。
            </p>
            <p>
                ダウンロードした電子書籍は、ダウンロード時点のものとなります。
                ダウンロード後に作者が内容を変更しても、その変更は反映されません。
                再度ダウンロードする必要があります。
            </p>
            <p>
                作者様が任意に電子書籍化を無効化している場合があります。
            </p>
            <h4>電子書籍の奨め</h4>
            <p>
                完結作品をご自身のペースでじっくり読むことは、貸し本棚サイト上でもできますが、
                電子書籍の方がページめくりや細かいブックマーク機能があり、フォントやレイアウトの調整が細かくできます。
                また、電波の届きにくいところで読む場合にも、電子書籍はダウンロード時以外は通信を行わないため、読めなくなるという問題が起きません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "電子書籍 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>